import React, { Component, ErrorInfo, ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
  // Changing this value clears the error, so navigating away recovers the page.
  resetKey?: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

const containerStyle: React.CSSProperties = {
  minHeight: "50vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 12,
  padding: "48px 24px",
  textAlign: "center",
};

const buttonStyle: React.CSSProperties = {
  background: "#483285",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  padding: "10px 24px",
  fontSize: 15,
  cursor: "pointer",
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidUpdate(prevProps: ErrorBoundaryProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Page crashed:", error, errorInfo.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={containerStyle}>
        <h2 style={{ margin: 0, fontSize: 20 }}>Something went wrong</h2>
        <p style={{ margin: 0, color: "#666", maxWidth: 420 }}>
          We couldn&apos;t load this page. Please try again.
        </p>
        <button type="button" style={buttonStyle} onClick={this.handleRetry}>
          Try again
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
